module.exports = __webpack_public_path__ + "static/media/dvd02.91eb4e24.jpg";